import { render, staticRenderFns } from "./caldeira.vue?vue&type=template&id=6cbeec02"
import script from "./caldeira.vue?vue&type=script&lang=js"
export * from "./caldeira.vue?vue&type=script&lang=js"
import style0 from "./caldeira.vue?vue&type=style&index=0&id=6cbeec02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports